import React from 'react';

// Shared, consistent styling for Task controls across the per-client Tasks tab
// and the portfolio page. Replaces the ad-hoc rainbow of reactstrap color props
// (info/primary/success/warning/secondary all at once) with one calm system:
//   - ONE filled "primary" = the main forward action (Done)
//   - neutral ghost buttons for secondary moves (Start, Reopen, Snooze)
//   - a restrained danger treatment for Dismiss
// so a row reads as "one obvious next step + quieter alternatives", not a
// christmas tree.

// Status badge palette — muted, semantic. ACCEPTED is retired from the rep UI
// (see lifecycle OPEN -> IN_PROGRESS -> DONE) but kept here so any legacy
// ACCEPTED rows still render with a sensible colour.
export const TASK_STATUS_COLOR = {
    OPEN: '#5b7083',
    ACCEPTED: '#16a085',
    IN_PROGRESS: '#2f6fed',
    DONE: '#1e8f5b',
    DEFERRED: '#8e44ad',
    DISMISSED: '#95a5a6',
};

const BTN_BASE = {
    fontSize: 12,
    fontWeight: 500,
    padding: '3px 10px',
    borderRadius: 6,
    lineHeight: 1.4,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
};

const VARIANTS = {
    primary: { ...BTN_BASE, background: '#1e8f5b', border: '1px solid #1e8f5b', color: '#fff' },
    neutral: { ...BTN_BASE, background: '#fff', border: '1px solid #ced6e0', color: '#485460' },
    danger: { ...BTN_BASE, background: '#fff', border: '1px solid #eec7c7', color: '#c0392b' },
    link: { ...BTN_BASE, background: 'transparent', border: '1px solid transparent', color: '#7f8c8d', padding: '3px 6px' },
};

// A single uniform task-action button. `variant` picks the treatment; every
// call site shares the same size/typography so the action cell is visually
// consistent on both surfaces.
export function TaskBtn({ variant = 'neutral', disabled, onClick, title, children, style }) {
    return (
        <button
            type='button'
            disabled={disabled}
            title={title}
            onClick={onClick}
            style={{ ...VARIANTS[variant], marginRight: 4, opacity: disabled ? 0.5 : 1, ...style }}
        >
            {children}
        </button>
    );
}

// Shared segmented "Sort" control — one consistent presentation for the Tasks
// tab, Findings tab, and the portfolio page. options: [{value,label}].
export function SortToggle({ value, onChange, options, label = 'Sort' }) {
    return (
        <div style={{ display: 'inline-flex', border: '1px solid #d7dce3', borderRadius: 6, overflow: 'hidden' }} title='Sort'>
            <span style={{ fontSize: 11, color: '#8a94a6', padding: '5px 8px', background: '#f7f9fc', borderRight: '1px solid #eef1f5' }}>{label}</span>
            {options.map((o, i) => (
                <button
                    key={o.value}
                    type='button'
                    onClick={() => onChange(o.value)}
                    style={{
                        fontSize: 12, padding: '5px 12px', cursor: 'pointer', border: 'none',
                        borderLeft: i === 0 ? 'none' : '1px solid #eef1f5',
                        background: value === o.value ? '#eef2fb' : '#fff',
                        color: value === o.value ? '#2f6fed' : '#57606f',
                        fontWeight: value === o.value ? 600 : 400,
                    }}
                >
                    {o.label}
                </button>
            ))}
        </div>
    );
}
